var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Bold/Vector",
    d: "M4.6748 1.3827V13.5139",
    stroke: "black",
    strokeWidth: 1.36476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Bold/Vector_2",
    d: "M7.94067 5.11525C7.94067 4.80889 7.88033 4.50552 7.76309 4.22248C7.64585 3.93944 7.474 3.68226 7.25737 3.46562C7.04074 3.24899 6.78356 3.07715 6.50052 2.95991C6.21747 2.84267 5.91411 2.78233 5.60774 2.78233H3.50811C2.88938 2.78233 2.29599 3.02812 1.85848 3.46562C1.42098 3.90313 1.17519 4.49652 1.17519 5.11525C1.17519 5.73398 1.42098 6.32737 1.85848 6.76488C2.29599 7.20239 2.88938 7.44818 3.50811 7.44818H6.07433C6.69306 7.44818 7.28645 7.69397 7.72396 8.13147C8.16147 8.56898 8.40725 9.16237 8.40725 9.7811C8.40725 10.3998 8.16147 10.9932 7.72396 11.4307C7.28645 11.8682 6.69306 12.114 6.07433 12.114H3.27482C2.65609 12.114 2.0627 11.8682 1.62519 11.4307C1.18768 10.9932 0.941895 10.3998 0.941895 9.7811",
    stroke: "black",
    strokeWidth: 1.36476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.5af9bf435409144158659d2168c09091.svg";
export { ForwardRef as ReactComponent };